import { render, staticRenderFns } from "./QueryRootsSelectRank.vue?vue&type=template&id=12a10198&scoped=true&"
import script from "./QueryRootsSelectRank.vue?vue&type=script&lang=js&"
export * from "./QueryRootsSelectRank.vue?vue&type=script&lang=js&"
import style0 from "./QueryRootsSelectRank.vue?vue&type=style&index=0&id=12a10198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a10198",
  null
  
)

export default component.exports